// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__q0n4h"};